/** 税费相关 */
export default [
    {
        path: 'taxesDues/service',
        name: 'taxesDuesService',
        meta: {
            title: '税费服务',
        },
        component: () => import('@/views/taxesDues/service.vue')
    },
    {
        path: 'taxesDues/compute',
        name: 'compute',
        meta: {
            title: '税费计算器',
            isShowTab: false,
            isLoading: true
        },
        component: () => import('@/views/taxesDues/compute.vue')
    },
    {
        path: 'taxesDues/calculationResult',
        name: 'calculationResult',
        meta: {
            title: '年度劳务测算结果',
        },
        component: () => import('@/views/taxesDues/calculationResult.vue')
    },
    {
        path: 'taxesDues/introduce',
        name: 'introduce',
        meta: {
            title: '结算方式介绍',
            isShowTab: false,
            isLoading: true
        },
        component: () => import('@/views/taxesDues/introduce.vue')
    },
    {
        path: 'taxesDues/modification',
        name: 'modification',
        meta: {
            title: '变更结算方式',
        },
        component: () => import('@/views/taxesDues/modification.vue')
    },
    {
        path: 'taxesDues/video',
        name: 'video',
        meta: {
            title: '视频介绍',
        },
        component: () => import('@/views/taxesDues/video.vue')
    },
]